var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "loading-content-container" },
    [
      !_vm.loaded
        ? _c(
            "div",
            {
              staticClass: "loading-overlay d-flex justify-content-center pt-5",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "b-row",
            [
              _c(
                "csp-desktop-info-card",
                {
                  attrs: {
                    cols: 12,
                    icon: "inticon-autoclaim_billing",
                    title: "Abrechnung",
                  },
                },
                [
                  _c("h2", [_vm._v("Rechtsanwalt / Schadendienstleister")]),
                  _vm._v(" "),
                  _c("csp-invoicing-modality-table", {
                    attrs: {
                      "invoice-recipient-options": _vm.invoiceRecipientOptions,
                      "no-rows-text":
                        "Es sind keine Rechtsanwälte oder Schadendienstleister zugewiesen.",
                      "table-fields": _vm.serviceProviderModalityTableFields,
                      "table-form": _vm.serviceProviderForm,
                    },
                  }),
                  _vm._v(" "),
                  _c("h2", [_vm._v("Autohaus")]),
                  _vm._v(" "),
                  _c("csp-invoicing-modality-table", {
                    attrs: {
                      "invoice-recipient-options": _vm.invoiceRecipientOptions,
                      "table-fields": _vm.carDealerModalityTableFields,
                      "table-form": _vm.carDealerForm,
                    },
                  }),
                  _vm._v(" "),
                  _c("h2", [
                    _vm._v("Gutachter / Sachverständigenorganisation"),
                  ]),
                  _vm._v(" "),
                  _c("csp-invoicing-modality-table", {
                    attrs: {
                      "invoice-recipient-options": _vm.invoiceRecipientOptions,
                      "no-rows-text": "Es sind keine Gutachter zugewiesen.",
                      "table-fields": _vm.serviceProviderModalityTableFields,
                      "table-form": _vm.appraiserForm,
                    },
                  }),
                  _vm._v(" "),
                  _c("csp-form-group-btn-submit", {
                    on: {
                      click: function ($event) {
                        return _vm.submit()
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }